let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gyQbS")).then(() => parcelRequire('lWB0f'));